module.exports = __webpack_public_path__ + "static/media/tmdb-logo.24a6fdb9.svg";